import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

require("es6-promise").polyfill();
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    navigation: state.navigation,
    dataRow: state.dataRow,
    invoice: state.invoice,
    escrowAccount: state.escrowAccount,
    isEscrow: state.isEscrow,
  }),
});

Vue.use(Vuex);
const state = {
  dataRow: {},
  invoice: {},
  escrowAccount: {},
  isEscrow: false,
};

const getters = {
  dataRow: (state) => {
    return state.dataRow;
  },
  invoice: (state) => {
    return state.invoice;
  },
  escrowAccount: (state) => {
    return state.escrowAccount;
  },
  isEscrow: (state) => {
    return state.isEscrow;
  },
};

const mutations = {
  SET_DATAROW: (state, newRow) => {
    state.dataRow = newRow;
  },
  SET_INVOICE: (state, newInvoice) => {
    state.invoice = newInvoice;
  },
  SET_ESCROWACCOUNT: (state, newEscrowAccount) => {
    state.escrowAccount = newEscrowAccount;
  },
  SET_IS_ESCROW: (state, newIsEscrow) => {
    state.isEscrow = newIsEscrow;
  },
};

const actions = {
  setDataRow: ({ commit, state }, newRow) => {
    commit("SET_DATAROW", newRow);
    return state.dataRow;
  },
  setInvoice: ({ commit, state }, newInvoice) => {
    commit("SET_INVOICE", newInvoice);
    return state.invoice;
  },
  setEscrowAccount: ({ commit, state }, newEscrowAccount) => {
    commit("SET_ESCROWACCOUNT", newEscrowAccount);
    return state.escrowAccount;
  },
  setIsEscrow: ({ commit, state }, newIsEscrow) => {
    commit("SET_IS_ESCROW", newIsEscrow);
    return state.isEscrow;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [vuexLocal.plugin],
  getters,
});
